/**
=========================================================
* Argon Dashboard 2 MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-material-ui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import React from "react";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";

// Argon Dashboard 2 MUI contexts
import { useArgonController } from "context";

function DetailedStaticsCard({ bgColor, title, count, percentage, icon, direction }) {
  console.log(bgColor);
  console.log(icon.color);
  const [controller] = useArgonController();
  const { darkMode } = controller;

  return (
    <Card>
      <ArgonBox
        bgColor={bgColor === "white" && darkMode ? "transparent" : bgColor}
        variant={bgColor === "white" && darkMode ? "contained" : "gradient"}
      >
        <ArgonBox p={2}>
          <ArgonBox display="flex" alignItems="center" gap={2}>
            {/* Icon */}
            <ArgonBox
              variant="gradient"
              bgColor={bgColor === "white" ? icon.color : "info"}
              color={icon.color}
              width="3rem"
              height="3rem"
              minWidth="3rem"
              borderRadius="section"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              {typeof icon.component === "string" ? (
                <Icon fontSize="small" color={icon.color}>
                  {icon.component}
                </Icon>
              ) : (
                <ArgonBox fontSize="1.125rem" display="grid" placeItems="center" color="white">
                  {icon.component}
                </ArgonBox>
              )}
            </ArgonBox>

            {/* Title and Count */}
            <ArgonBox flex={1} lineHeight={1}>
              <ArgonTypography
                variant="button"
                color={bgColor === "white" ? "dark" : ""}
                textTransform="uppercase"
                fontWeight="medium"
                fontSize="0.75rem"
              >
                {title}
              </ArgonTypography>
              <ArgonTypography
                variant="h5"
                fontWeight="bold"
                color={bgColor === "white" ? "dark" : ""}
              >
                {count}
              </ArgonTypography>
            </ArgonBox>
          </ArgonBox>
        </ArgonBox>
      </ArgonBox>
    </Card>
  );
}

// Setting default values for the props of DetailedStaticsCard
DetailedStaticsCard.defaultProps = {
  bgColor: "white",
  percentage: {
    color: "success",
    count: 0,
    text: "",
  },
  direction: "right",
};

// Typechecking props for the DetailedStaticsCard
DetailedStaticsCard.propTypes = {
  bgColor: PropTypes.oneOf([
    "transparent",
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    color: PropTypes.oneOf([
      "primary",
      "secondary",
      "info",
      "success",
      "warning",
      "error",
      "dark",
      "white",
    ]),
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string,
  }),
  icon: PropTypes.shape({
    color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
    component: PropTypes.node.isRequired,
  }).isRequired,
  direction: PropTypes.oneOf(["right", "left"]),
};

export default DetailedStaticsCard;
